export default class PersonalizeTab {

    constructor() {
        this.addEvents();

        if($('body').find('.personalize-tab').length > 0) {
            this.checkMobileView();
            this.handleResize();
        }

        this.tabsSwiperInstance = null;
    }

    addEvents() {
        const swiperInstance = document.querySelector('.personalize-tab .personalize-tab__list.slider')?.swiper;

        if(swiperInstance) {
            swiperInstance.off('slideChange').on('slideChange', function (swiper) {
                const swiperTabSlide = $('.personalize-tab .personalize-tab__wrapper').find('.swiper-slide');
                const currentSlideVideos = swiper.slides[swiper.previousIndex].querySelectorAll('iframe,video');
                currentSlideVideos.forEach(video => {
                    const src = video.src;
                    $(`.personalize-tab .mfp-iframe.wistia_embed[src="${src}"]`).each(function () {
                        const originalSrc = $(this)[0].src;
                        video.src = '';
                        video.src = originalSrc;
                    })

                });

                if(!swiperTabSlide.length){
                    const contentActiveIndex = swiper.activeIndex;
                    const activeSlide = swiper.slides[contentActiveIndex];
                    let activeIndex = parseInt(activeSlide?.getAttribute('data-swiper-slide-index')) + 1;

                    $('.personalize-tab__tab.active').removeClass('active');
                    $(`.personalize-tab__tab:nth-of-type(${activeIndex})`).addClass('active')
                }

            });

            $('.personalize-tab .personalize-tab__wrapper .personalize-tab__tab').on('click', function () {
                const swiperTabSlide = $('.personalize-tab .personalize-tab__wrapper').find('.swiper-slide');

                if(!swiperTabSlide.length){
                    swiperInstance.slideTo($(this).index())
                }

            })

        }

        if($('.personalize-tab__left .wistia-container').length) {
            $('.personalize-tab__left .wistia-container .wistia-container__video').each(function() {
                let video = $(this).attr('data-src');
                if(video) {
                    if (video.includes('youtube.com') || video.includes('youtu.be')) {
                        // Extract the YouTube video ID
                        const youtubeId = video.split('v=')[1] || video.split('/').pop();
                        video = 'https://www.youtube.com/embed/' + youtubeId;
                    } else {
                        video = 'https://fast.wistia.net/embed/iframe/' + (video.split('medias/')[1] || video.split('medias/')[0]);
                    }

                    $('body').prepend('<script src="https://fast.wistia.com/assets/external/E-v1.js"></script>')

                    $('<iframe>', {
                        class: 'mfp-iframe wistia_embed',
                        src: video,
                        frameborder: 0,
                        allowfullscreen: true,
                        loading: 'lazy'
                    }).appendTo($(this).parents('.personalize-tab__left .wistia-container'));

                }
            })
        }

    }

    checkMobileView() {
        if ($(window).width() <= 767) {
            this.activateSwiper();
        } else {
            this.deactivateSwiper();
        }
    }

    handleResize() {
        $(window).on('resize', () => {
            this.checkMobileView();
        });
    }

    activateSwiper() {
        if (!this.tabsSwiperInstance) {
            const slider = this.prepareSlider();
            $('.personalize-tab .personalize-tab__tab').addClass('slider');
            let sladeChanged = false;
            let tabChanged = false;

            this.tabsSwiperInstance = new Swiper(slider, {
                direction: 'horizontal',
                slidesPerView: 1,
                centeredSlides: true,
                speed: 500,
                loop: true,
                spaceBetween: 0,
                navigation: {
                    nextEl: '.personalize-tab__nav--right img',
                    prevEl: '.personalize-tab__nav--left img',
                },
                on: {
                    init: () => {
                        $(slider).addClass('swiper-initialized swiper-horizontal swiper-pointer-events has-multiple-slides has-transition-slide small-gutters');
                        const swiperInstance = document.querySelector('.personalize-tab .personalize-tab__list.slider')?.swiper;
                        const swiperTab = slider.swiper;

                        if (swiperInstance) {
                            swiperInstance.on('slideChange', function (swiper) {
                                if(sladeChanged) {
                                    sladeChanged = false;
                                    return;
                                }

                                const contentActiveIndex = swiper.activeIndex;
                                const activeSlide = swiper.slides[contentActiveIndex];
                                let tabContentIndex = parseInt(activeSlide?.getAttribute('data-swiper-slide-index'));
                                tabContentIndex = tabContentIndex + 1;

                                tabChanged = true;

                                if(swiperTab && swiperTab.slideTo) {
                                    swiperTab.slideTo(tabContentIndex);
                                }
                            });
                        }
                    },
                    slideChange: (swiper) => {
                        const swiperInstance = document.querySelector('.personalize-tab .personalize-tab__list.slider').swiper;
                        const activeIndex = swiper.activeIndex;
                        const tabIndex = swiper.slides[activeIndex]?.getAttribute('data-swiper-slide-index');

                        if (swiperInstance && !tabChanged) {
                            sladeChanged = true;
                            swiperInstance.slideTo(tabIndex);
                        } else {
                            tabChanged = false
                        }

                    },
                    transitionEnd: (swiper) => {
                        $('.personalize-tab__wrapper .swiper-slide .personalize-tab__tab').removeClass('active');
                        $('.personalize-tab__wrapper .swiper-slide-active .personalize-tab__tab').addClass('active');
                    }
                },
            });

        }
    }

    deactivateSwiper() {
        if (this.tabsSwiperInstance) {

            this.tabsSwiperInstance = null;

            const slider = document.querySelector('.personalize-tab .personalize-tab__tabs .personalize-tab__wrapper');

            if(!slider) return;

            slider.swiper = null;

            $(slider).removeClass('swiper-initialized swiper-horizontal swiper-pointer-events has-multiple-slides has-transition-slide small-gutters');

            $('.personalize-tab__tab.slider').each(function() {

                $(this).removeClass('slider')
                let clonedTab = '';
                if ($(this).parent().hasClass('swiper-slide')) {

                    if(!$(this).parent().hasClass('swiper-slide-duplicate')){
                        clonedTab = $(this).detach();
                    }

                    if(clonedTab && clonedTab.hasClass('personalize-tab__tab')){
                        $('.personalize-tab__tabs .personalize-tab__wrapper .slides.swiper-wrapper').append(clonedTab);
                    }

                }
            });

            if($('.personalize-tab__tabs .personalize-tab__wrapper .swiper-wrapper').find('.swiper-slide').length > 0) {
                $('.personalize-tab__tabs .personalize-tab__wrapper .swiper-wrapper').find('.personalize-tab__tab:first-of-type').addClass('active')
                $('.personalize-tab__tabs .personalize-tab__wrapper .slides.swiper-wrapper').find('.swiper-slide').each(function () {
                    $(this).remove();
                });
            }

        }
    }

    prepareSlider() {
        const slider = document.querySelector('.personalize-tab .personalize-tab__tabs .personalize-tab__wrapper');

        if(!slider) return ;

        const slideWrapper = slider.querySelector('.personalize-tab__tabs .personalize-tab__wrapper .slides');
        const slides = Array.from(slideWrapper.children);

        slideWrapper.classList.add('swiper-wrapper');

        slides.forEach(s => {
            const sSlide = document.createElement('div');
            sSlide.classList.add('swiper-slide');
            s.parentNode.insertBefore(sSlide, s);
            sSlide.appendChild(s);
        });

        return slider;
    }

}